import { useMutation, useQueryClient } from "@tanstack/react-query";
import { privateAxios } from "../../axiosInstances";
import { eventsQueryKeys } from "../../query-keys";
import { activitiesRequestsQueryKeys } from "../../query-keys/events/activities-requests.query-keys";

export type AccuseActivityProgramRequestData = {
  mode: "refuse" | "accept";
  activityId: string;
  placeName?: string;
};

const accuseActivityProgramRequest = async (
  eventId: string,
  data: AccuseActivityProgramRequestData
) => {
  const { data: response } = await privateAxios.post(
    `/events/${eventId}/activities/requests`,
    data
  );
  return response;
};

export const useAccuseActivityProgramRequestMutation = (eventId: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: AccuseActivityProgramRequestData) =>
      accuseActivityProgramRequest(eventId, data),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: activitiesRequestsQueryKeys.event(eventId),
      });
      queryClient.invalidateQueries({
        queryKey: eventsQueryKeys.get(eventId),
      });
    },
  });
};
